import * as React from 'react';
import cn from 'clsx';
import styles from '@sicredi/styles/_labelled-value.scss';

import Item, { Props as ItemProps } from './Item';

export interface Schema extends React.HTMLAttributes<HTMLDListElement> {}

export interface Props extends Schema {
  children?: React.ReactNode;
  compact?: boolean; // https://developer.mozilla.org/pt-BR/docs/Web/HTML/Element/dl#attr-compact
}
export interface CompoundedLabelledValue extends React.FC<Props> {
  Item: React.FC<ItemProps>;
}

const LabelledValue: CompoundedLabelledValue = ({
  compact,
  children,
  className,
  ...props
}) => (
  <dl
    className={cn(styles['sicredi-labelled-value'], className, {
      [styles['-compact']]: compact
    })}
    {...props}
  >
    {children}
  </dl>
);

LabelledValue.Item = Item;

export default LabelledValue;
